module.exports = {
  "zones": {
    "America/Argentina/Salta": ["z", {
      "wallclock": 1224288000000,
      "format": "-03",
      "abbrev": "-03",
      "offset": -10800000,
      "posix": 1224298800000,
      "save": 0
    }, {
      "wallclock": 952041600000,
      "format": "-03/-02",
      "abbrev": "-03",
      "offset": -10800000,
      "posix": 952052400000,
      "save": 0,
      "rules": "Arg"
    }, {
      "wallclock": 938908800000,
      "format": "-04/-03",
      "abbrev": "-03",
      "offset": -14400000,
      "posix": 938919600000,
      "save": 3600000,
      "rules": "Arg"
    }, {
      "wallclock": 687916800000,
      "format": "-03/-02",
      "abbrev": "-02",
      "offset": -10800000,
      "posix": 687931200000,
      "save": 3600000,
      "rules": "Arg"
    }, {
      "wallclock": 667958400000,
      "format": "-04",
      "abbrev": "-04",
      "offset": -14400000,
      "posix": 667965600000,
      "save": 0
    }, {
      "wallclock": -7603200000,
      "format": "-03/-02",
      "abbrev": "-03",
      "offset": -10800000,
      "posix": -7588800000,
      "save": 0,
      "rules": "Arg"
    }, {
      "wallclock": -1233446400000,
      "format": "-04/-03",
      "abbrev": "-03",
      "offset": -14400000,
      "posix": -1233432000000,
      "save": 3600000,
      "rules": "Arg"
    }, {
      "wallclock": -1567468800000,
      "format": "-04",
      "abbrev": "-04",
      "offset": -14400000,
      "posix": -1567453392000,
      "save": 0
    }, {
      "wallclock": -2372112000000,
      "format": "CMT",
      "abbrev": "CMT",
      "offset": -15408000,
      "posix": -2372096300000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -15700000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Arg": [{
      "from": 2008,
      "to": 2009,
      "month": 2,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2008,
      "to": 2008,
      "month": 9,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2007,
      "to": 2007,
      "month": 11,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2000,
      "to": 2000,
      "month": 2,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 1999,
      "to": 1999,
      "month": 9,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1989,
      "to": 1993,
      "month": 2,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1989,
      "to": 1992,
      "month": 9,
      "day": [0, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1988,
      "to": 1988,
      "month": 11,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 0,
      "day": [7, 23],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1968,
      "to": 1969,
      "month": 3,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1967,
      "to": 1968,
      "month": 9,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1967,
      "to": 1967,
      "month": 3,
      "day": [7, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1964,
      "to": 1966,
      "month": 2,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1964,
      "to": 1966,
      "month": 9,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1963,
      "to": 1963,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1963,
      "to": 1963,
      "month": 11,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 2,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1946,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1943,
      "month": 7,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 9,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1941,
      "to": 1941,
      "month": 5,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1941,
      "to": 1941,
      "month": 9,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1932,
      "to": 1940,
      "month": 2,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 6,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1932,
      "to": 1939,
      "month": 10,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1931,
      "to": 1931,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1931,
      "to": 1931,
      "month": 9,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1930,
      "to": 1930,
      "month": 11,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};